{
    "STARTPAGE": {
        "FOOTER": {
            "TERMS_OF_USE": "Nutzungsbedingungen"
        }
    },
    "DOWNLOAD_PAGE": {
        "STARTPAGE": "Zur Startseite"
    },
    "PASSWORD_RECOVERY": {
        "TITLE": "Passwort zurücksetzen",
        "USER_NAME": "Benutzername",
        "SEND": "Absenden"
    },
    "PASSWORD_RESET": {
        "TITLE": "Neues Passwort setzen",
        "TOKEN": "Ihr Link ist ungültig.",
        "SAVE": "Speichern",
        "LABEL": {
            "USER_NAME": "Ihr Benutzername ist: ",
            "PASSWORD": "Neues Passwort",
            "CONFIRM_PASSWORD": "Neues Passwort wiederholen"
        },
        "ERROR_MESSAGE": {
            "CONFIRM_PASSWORD": "Passwort stimmt nicht überein"
        }
    },
    "HEADER": {
        "USER_PROFILE": "Profil",
        "NOTIFICATIONS": "Benachrichtigungen",
        "LOGOUT": "Abmelden"
    },
    "MORE_NAVIGATION": {
        "ABOUT": "Über GeoBus",
        "IMPRESSUM": "Impressum"
    },
    "SIDE_MENU": {
        "GENERAL": {
            "CATEGORY": "Allgemein",
            "TO_DO": "Pendenzenliste",
            "TRACKINGS": "Geodaten"
        },
        "USER_ORGANISATION": {
            "CATEGORY": "Benutzer & Organisation",
            "USER_ADMIN": "Benutzer",
            "ORGANISATION": "Organisationen"
        },
        "DATA": {
            "CATEGORY": "Stammdaten",
            "TOPICS": "Themen",
            "MODELS": "Modelle",
            "COMMUNITY": "Gebiet",
            "FTP_SERVER": "FTP-Server"
        }
    },
    "NAVIGATION": {
        "BACK": "Zurück",
        "SAVE": "Speichern",
        "ABORT": "Abbrechen"
    },
    "GRID_FILTER": {
        "YES": "Ja",
        "NO": "Nein"
    },
    "SWITCH": {
        "YES": "Ja",
        "NO": "Nein"
    },
    "MESSAGE": {
        "CHECK": "Bitte warten. Die Interlis-Datei wird überprüft.",
        "DOWNLOAD": "Bitte warten. Die GeoPackage-Datei wird heruntergeladen."
    },
    "GEOBUS_EDIT": {
        "USER_EDIT": "Benutzer bearbeiten"
    },
    "TO_DO": {
        "GRID": {
            "TOPIC_NAME": "Thema",
            "MODEL_NAME": "Modell",
            "GEMEINDE_NAME": "Gebiet",
            "CHECKOUT_DATE": "Bezogen am",
            "DUE_DATE": "Fälligkeit",
            "EXTSTATUS": "Status",
            "ZS": "Zuständige Stelle",
            "NS": "Nachführende Stelle"
        },
        "EDIT": "Datensatz anzeigen"
    },
    "USER": {
        "GRID": {
            "SALUTATION": "Anrede",
            "LASTNAME": "Name",
            "FIRSTNAME": "Vorname",
            "EMAIL": "E-Mail",
            "PHONE": "Telefon",
            "ORGANISATION": "Organisation",
            "USERNAME": "Benutzername",
            "ROLE_NAMES": "Rollen",
            "ACTIVE": "Aktiv"
        },
        "BUTTON": {
            "EDIT": "Benutzer bearbeiten",
            "SHOW_DELETED": "Gelöschte Benutzer anzeigen",
            "DELETE": "Benutzer löschen",
            "CREATE": "Neuen Benutzer erstellen"
        }
    },
    "USER_EDIT": {
        "TITLE_NEW": "Benutzerverwaltung: Neuer Benutzer",
        "TITLE_CURRENT": "Profil bearbeiten",
        "LABEL": {
            "SALUTATION": "Anrede",
            "USERNAME": "Benutzername",
            "FIRSTNAME": "Vorname",
            "LASTNAME": "Nachname",
            "PASSWORD": "Neues Passwort",
            "ORGANISATION": "Organisation",
            "EMAIL": "E-Mail",
            "TELEFON": "Telefon"
        },
        "ERROR_MESSAGE": {
            "USERNAME": "Benutzername existiert bereits",
            "PASSWORD": "Passwort fehlt",
            "EMAIL_EXISTING": "Email existiert bereits"
        }
    },
    "VALIDATION": {
        "EMAIL_NOTVALID": "E-Mail ist nicht gültig"
    },
    "TRACKING": {
        "GRID": {
            "TOPIC": "Thema",
            "MODEL_NAME": "Modell",
            "MODEL_VERSION": "Version",
            "GEMEINDE_NAME": "Gebiet",
            "ZS": "Zuständige Stelle",
            "NS": "Nachführende Stelle",
            "TP": "Technische Prüfstelle",
            "CHECKOUT_DATE": "Nachführungsbeginn",
            "MAX_CHECKOUT_PERIOD": "Nachführungszeitraum",
            "INTEGRATION_FILENAME": "Integration"
        },
        "EDIT": "Nachführungsauftrag bearbeiten",
        "SHOW_DATASETS": "Nachführungsverlauf anzeigen",
        "DELETE": "Nachführungsauftrag löschen",
        "CREATE": "Neuen Nachführungsauftrag erfassen",
        "EDIT_DISTRIBUTION": "Verteilungskonfiguration"
    },
    "TRACKING_EDIT": {
        "TITLE": "Neuer Nachführungsauftrag",
        "TOPIC": "Thema",
        "MODEL": "Modell",
        "GEMEINDE": "Gebiet",
        "PERIOD": "Nachführungszeitraum (in Tagen)",
        "ZS": "Zuständige Stelle",
        "TP": "Technische Prüfstelle",
        "NS": "Nachführende Stellen"
    },
    "PROTOCOL": {
        "TITLE": "Protokoll",
        "GRID": {
            "TASK_NR": "Task-Nr",
            "TASK": "Task",
            "USER": "Benutzer",
            "DATE": "Datum",
            "TIME": "Zeit",
            "RESULT": "Resultat Prüfung",
            "STATUS": "Status",
            "NOTE": "Notiz"
        }
    },
    "ORGANISATION": {
        "GRID": {
            "NAME": "Name",
            "PHONE": "Telefon",
            "EMAIL": "E-Mail",
            "ADDRESS": "Adresse",
            "ACTIVE": "Aktiv"
        },
        "EDIT": "Organisation bearbeiten",
        "SHOW_DATASETS": "Datensätze anzeigen",
        "DELETE": "Organisation löschen",
        "CREATE": "Neue Organisation erfassen",
        "SHOW_DELETED": "Gelöschte Organisationen anzeigen"
    },
    "ORGANISATION_EDIT": {
        "TITLE": "Erstellung einer neuen Organisation",
        "NAME": "Name",
        "STREET": "Strasse",
        "PLZ": "PLZ",
        "CITY": "Ort",
        "EMAIL": "E-Mail",
        "PHONE": "Telefon"
    },
    "TOPIC": {
        "GRID": {
            "NAME": "Name"
        },
        "EDIT": "Thema bearbeiten",
        "DELETE": "Thema löschen",
        "CREATE": "Neues Thema erstellen"
    },
    "TOPIC_EDIT": {
        "TITLE": "Neues Thema erstellen",
        "TOPIC": "Thema",
        "LOADING_FAILED": "Das Thema konnte nicht geladen werden"
    },
    "MODEL": {
        "GRID": {
            "TOPIC_NAME": "Thema",
            "NAME": "Name",
            "VERSION": "Version",
            "PRIVATE": "Privates Modell",
            "FROM_DATE": "Datum",
            "FORMAT": "Format",
            "INTERLIS_FORMAT": "Kantonal-/Bundesmodell",
            "EXTENDED_TECHNICAL_CHECK": "Erweiterte Technische Prüfung",
            "VISUALIZATION": "Visualisierung",
            "GEOPORTAL": "Geoportal relevant",
            "ÖREB": "ÖREB-Portal relevant",
            "MODEL": "Modell",
            "DESCRIPTION": "Beschreibung",
            "CANTON_ID": "Kanton"
        },
        "EDIT": "Modell bearbeiten",
        "DELETE": "Modell löschen",
        "CREATE": "Neues Modell erstellen",
        "DOWNLOAD_GUIDELINE": "Download Beschreibung",
        "DOWNLOAD_MODEL": "Download Modell",
        "DOWNLOAD_MODELS": "Download Modelle"
    },
    "MODEL_EDIT": {
        "TITLE": "Neues Modell erstellen",
        "MODEL": "Modell",
        "TOPIC": "Gültig für Thema",
        "VERSION": "Version",
        "PRIVATE": "Nicht öffentlich",
        "DATE": "Ab Datum",
        "FILE": "Modell-Datei",
        "CURRENT": "Aktuell: ",
        "MAP_ID": "Karten-ID",
        "DESCRIPTION": "Modellbeschreibung",
        "TRACKING_ID": "Datenbestands-ID",
        "FORMAT": "Format",
        "TP": "Erweiterte techn. Prüfung",
        "VISUALIZATION": "Visualisierung",
        "MODEL_TYPE": "Kantonal-/Bundesmodell",
        "GEOPORTAL": "Geoportal relevant",
        "ÖREB": "ÖREB-Portal relevant",
        "LOADING_FAILED": "Modell konnte nicht geladen werden"
    },
    "GEMEINDE": {
        "GRID": {
            "NAME": "Name",
            "BFSNR": "BFSNR",
            "PRIMARYAREA": "Primärregion"
        },
        "EDIT": "Gebiet bearbeiten",
        "DELETE": "Gebiet löschen",
        "CREATE": "Neues Gebiet definieren"
    },
    "GEMEINDE_EDIT": {
        "TITLE": "Neues Gebiet definieren",
        "AREA": "Gebiet",
        "BFSNR": "BFSNR",
        "PRIMARY_AREA": "Primärregion"
    },
    "FTP_SERVER": {
        "GRID": {
            "TYPE": "Typ",
            "SERVER": "Server",
            "PORT": "Port"
        },
        "BUTTON": {
            "NEW": "Neuer FTP-Server",
            "DELETE": "FTP-Server löschen",
            "EDIT": "FTP-Server bearbeiten"
        },
        "TYPES": {
            "GEOPORTAL": "Geoportal",
            "KKGEO": "KKGEO",
            "GIS_FACHSTELLE": "GIS-Fachstelle",
            "CUSTOM": "Benutzerdefiniert"
        },
        "MESSAGE": {
            "DELETE_SUCCESS": "FTP-Server erfolgreich gelöscht",
            "DELETE_FAILURE": "FTP-Server konnte nicht gelöscht werden",
            "LOADING_FAILED": "FTP-Server konnte nicht geladen werden"
        }
    },
    "FTP_SERVER_EDIT": {
        "TITLE": "Neuen Server definieren",
        "TYPE": "Typ",
        "SERVER_TYPE": "Servertyp",
        "SERVER": "Server",
        "PORT": "Port",
        "USER_NAME": "Benutzername",
        "PASSWORD": "Passwort",
        "DIRECTORY": "Verzeichnis",
        "MESSAGE": {
            "SAVE_SUCCESS": "FTP-Server erfolgreich gespeichert",
            "SAVE_FAILURE": "FTP-Server konnte nicht gespeichert werden"
        }
    },
    "DISTRIBUTION": {
        "TITLE": "Verteilung Nachführungsauftrag",
        "GRID": {
            "TYPE": "Typ",
            "TARGET": "E-Mail/FTP Server",
            "NEXT_EXECUTION": "Erste/Nächste Ausführung des Intervalls"
        },
        "TYPES": {
            "NEW": "(Neue Verteilungskonfiguration)",
            "FTP": "FTP",
            "SFTP": "SFTP",
            "MAIL": "E-Mail"
        },
        "BUTTON": {
            "NEW": "Neue Verteilung",
            "DELETE": "Verteilung löschen",
            "EDIT": "Verteilung bearbeiten"
        },
        "MESSAGE": {
            "SAVE_SUCCESS": "Verteilungskonfiguration erfolgreich gelöscht",
            "SAVE_FAILURE": "Verteilungskonfiguration konnte möglicherweise nicht gelöscht werden"
        }
    },
    "DISTRIBUTION_EDIT": {
        "TITLE": "Verteilungkonfiguration:",
        "TITLE_NEW": "Neue Verteilungkonfiguration",
        "TYPE": "Typ",
        "EMAIL": "E-Mail-Adresse",
        "EXPORT": "Exportformat",
        "MODEL": "Kantonal-/Bundesmodell",
        "INTERVAL_NUMBER": "Anzahl Tage /Monate",
        "INTERVAL_TYPE": "Intervall-Art",
        "NEXT_EXECUTION": "Erste/Nächste Ausführung Intervalls",
        "END": "Bei Ende der Nachführung auslösen",
        "MESSAGE": {
            "DATE_INVALID": "Angegebenes Ausführungsdatum ist ungültig.\"",
            "SAVE_SUCCESS": "Verteilungskonfiguration erfolgreich gespeichert"
        }
    },
    "DATASET_LIST": {
        "TITLE": "Daten Nachführungsverlauf",
        "GRID": {
            "STATUS": "Status",
            "TOPIC": "Thema",
            "MODEL": "Modell",
            "GEMEINDE": "Gebiet",
            "CHECKOUT_DATE": "Check-out-Datum",
            "CHECKOUT_USER": "Check-out-Benutzer",
            "CHECKIN_DATE": "Check-in-Datum",
            "CHECKIN_USER": "Check-in-Benutzer",
            "TP": "Technische Prüfung",
            "EXTENDED_TP": "Erweiterte technische Prüfung",
            "FP": "Fachliche Prüfung"
        },
        "BUTTON": {
            "SHOW": "Nachführungsschritt anzeigen",
            "CHECKIN": "Check-in",
            "CHECKOUT": "Check-out",
            "DOWNLOAD": "Download Daten",
            "PROTOCOL": "Protokoll anzeigen"
        },
        "TOOLTIP": {
            "CHECKED_OUT": "Ausgecheckter Datensatz",
            "VALID": "Aktueller gültiger Datensatz",
            "GEOPORTAL": "Erfolgreiche Publikation ins Geoportal",
            "ÖREB": "Erfolgreiche Publikation ins ÖREB",
            "FP_OKAY": "Fachliche Prüfung in Ordnung",
            "FP_NOT_OKAY": "Fachliche Prüfung nicht in Ordnung",
            "UNKNOWN": "Unbekannter Status"
        },
        "DOWNLOAD": {
            "ALERT_1": "Die Datei, die Sie herunterladen möchten, ist eine Kopie der Originaldaten. Diese Kopie kann nicht mehr in den GEOBUS geladen werden. Bitte akzeptieren Sie die",
            "ALERT_2": ", um den Download der Daten zu starten.",
            "TERMS": "Nutzungsbedingungen",
            "CANTON_MERGE": "Kantonsmerge starten",
            "ACCEPT": "Akzeptieren und Download starten",
            "DOWNLOAD": "Download"
        },
        "CHECK_IN": {
            "TITLE": "Check-in:",
            "FILE": "Datei wählen",
            "DESCRIPTION": "Beschreibung der Nachführung",
            "NOTIFICATION": "Check-in läuft"
        },
        "CHECK_OUT": {
            "TITLE": "Check-out"
        },
        "DATASET_DIALOG": {
            "CHOOSE": "Bitte wählen Sie",
            "LABEL": {
                "OKAY": "Datensatz in Ordnung",
                "NOT_OKAY": "Datensatz nicht in Ordnung"
            },
            "BUTTON": {
                "OKAY": "In Ordnung",
                "NOT_OKAY": "Nicht in Ordnung"
            },
            "EXTENDED_TECH": {
                "OKAY": {
                    "TEXT": "Mit diesem Befehl bestätigen Sie manuell, dass Sie den nachgeführten Datensatz erweitert technisch überprüft haben und diesen für die weitere Nutzung durch berechtigte Stellen zulassen."
                },
                "NOT_OKAY": {
                    "TEXT": "Mit dem Befehl bestätigen Sie manuell, dass Sie den nachgeführten Datensatz erweitert technisch überprüft haben, diesen aber nicht für die weitere Nutzung durch berechtigte Stellen genehmigen."
                },
                "FILE": "Datei wählen (nur PDF-Format)"
            },
            "TECH": {
                "OKAY": {
                    "TEXT": "Mit diesem Befehl bestätigen manuell, dass Sie den Nachgeführten Datensatz technisch überprüft haben und diesen für die weitere Nutzung durch berechtigte Stellen zulassen."
                },
                "NOT_OKAY": {
                    "TEXT": "Mit dem Befehl bestätigen Sie manuell, dass Sie den nachgeführten Datensatz technisch überprüft haben, diesen aber nicht für die weitere Nutzung durch berechtigte Stellen genehmigen.",
                    "COMMENT": "Bitte einen Kommentar eingeben."
                }
            },
            "PRO": {
                "OKAY": {
                    "TEXT": "Mit diesem Befehl bestätigen Sie, dass Sie den nachgeführten Datensatz fachlich überprüft haben und diesen für die weitere Nutzung durch berechtigte Stellen zulassen."
                },
                "NOT_OKAY": {
                    "TEXT": "Mit dem Befehl bestätigen Sie, dass Sie den nachgeführten Datensatz fachlich überprüft haben, diesen aber nicht für die weitere Nutzung durch berechtigte Stellen genehmigen.",
                    "COMMENT": "Bitte einen Kommentar eingeben."
                }
            }
        }
    },
    "DATASET_EDIT": {
        "TITLE": "Nachführungsschritt",
        "STATUS": "Status",
        "LABEL": {
            "RESULT": "Resultat",
            "NOTE": "Notiz",
            "DATE": "Datum",
            "USER": "Benutzer",
            "PROTOCOL": "Prüfprotokoll"
        },
        "BUTTON": {
            "CHECK": "Prüfen"
        },
        "DATASET": {
            "TITLE": "Übersicht Datensatz",
            "LABEL": {
                "TOPIC": "Thema",
                "AREA": "Gebiet",
                "MODEL": "Modell",
                "MODEL_VERSION": "Modell-Version",
                "CHECKOUT_DATE": "Check-out-Datum",
                "CHECKOUT_USER": "Check-out-Benutzer"
            }
        },
        "TECH_CHECK": {
            "TITLE": "Technische Prüfung",
            "LABEL": {
                "FILE": "Dateiname",
                "CHECKIN_DATE": "Check-in-Datum",
                "CHECKIN_USER": "Check-in-Benutzer"
            },
            "BUTTON": {
                "REPORT": "Fehlerdatei"
            }
        },
        "MANUAL_TECH": {
            "TITLE": "Manuelle techn. Prüfung",
            "LABEL": {
            }
        },
        "EXTENDED_TECH": {
            "TITLE": "Erweiterte techn. Prüfung",
            "LABEL": {
                "STATUS": "Status"
            },
            "BUTTON": {
                "PROTOCOL": "Prüfprotokoll"
            }
        },
        "VISUALIZATION": {
            "TITLE": "Visualisierung",
            "OBJECT": "Objekt/e",
            "LABEL": {
                "TOTAL": "Betroffen",
                "DATA_EDIT": "Datenänderung in",
                "GEOM_EDIT": "Geometrieänderung in",
                "NEW": "Neu",
                "DELETED": "Gelöscht"
            },
            "BUTTON": {
                "PROTOCOL": "Änderungsprotokoll",
                "VISUALIZATION": "Visualisierung"
            }
        },
        "EXPERT_CHECK": {
            "TITLE": "Fachliche Prüfung"
        },
        "PUBLICATION": {
            "TITLE": "Publikation",
            "TITLE_FTP": "Upload Geoportal-FTP",
            "TITLE_GEOPORTAL": "Geoportal-Publikation",
            "TITLE_ÖREB": "ÖREB-Publikation",
            "LABEL": {
                "APPROVAL_DATE": "Datum Freigabe",
                "USER": "Benutzer Freigabe",
                "PUBLICATION_DATE": "Datum Publikation"
            },
            "BUTTON": {
                "PUBLICATION": "Publikation"
            }
        }
    },
    "DOWNLOAD": {
        "ALERT_1": "Die Datei, die Sie herunterladen möchten, ist eine Kopie der Originaldaten. Diese Kopie kann nicht mehr in den GEOBUS geladen werden. Bitte akzeptieren Sie die",
        "ALERT_2": ", um den Download der Daten zu starten.",
        "TERMS": "Nutzungsbedingungen",
        "CANTON_MERGE": "Kantonsmerge starten",
        "ACCEPT": "Akzeptieren und Download starten",
        "DOWNLOAD": "Download"
    },
    "CHECK_IN": {
        "TITLE": "Check-in:",
        "FILE": "Datei wählen",
        "DESCRIPTION": "Beschreibung der Nachführung",
        "NOTIFICATION": "Check-in läuft"
    },
    "CHECK_OUT": {
        "TITLE": "Check-out"
    },
    "DATASET_DIALOG": {
        "CHOOSE": "Bitte wählen Sie",
        "LABEL": {
            "OKAY": "Datensatz in Ordnung",
            "NOT_OKAY": "Datensatz nicht in Ordnung"
        },
        "BUTTON": {
            "OKAY": "In Ordnung",
            "NOT_OKAY": "Nicht in Ordnung"
        },
        "EXTENDED_TECH": {
            "OKAY": {
                "TEXT": "Mit diesem Befehl bestätigen Sie manuell, dass Sie den nachgeführten Datensatz erweitert technisch überprüft haben und diesen für die weitere Nutzung durch berechtigte Stellen zulassen."
            },
            "NOT_OKAY": {
                "TEXT": "Mit dem Befehl bestätigen Sie manuell, dass Sie den nachgeführten Datensatz erweitert technisch überprüft haben, diesen aber nicht für die weitere Nutzung durch berechtigte Stellen genehmigen."
            },
            "FILE": "Datei wählen (nur PDF-Format)"
        },
        "TECH": {
            "OKAY": {
                "TEXT": "Mit diesem Befehl bestätigen manuell, dass Sie den Nachgeführten Datensatz technisch überprüft haben und diesen für die weitere Nutzung durch berechtigte Stellen zulassen."
            },
            "NOT_OKAY": {
                "TEXT": "Mit dem Befehl bestätigen Sie manuell, dass Sie den nachgeführten Datensatz technisch überprüft haben, diesen aber nicht für die weitere Nutzung durch berechtigte Stellen genehmigen.",
                "COMMENT": "Bitte einen Kommentar eingeben."
            }
        },
        "PRO": {
            "OKAY": {
                "TEXT": "Mit diesem Befehl bestätigen Sie, dass Sie den nachgeführten Datensatz fachlich überprüft haben und diesen für die weitere Nutzung durch berechtigte Stellen zulassen."
            },
            "NOT_OKAY": {
                "TEXT": "Mit dem Befehl bestätigen Sie, dass Sie den nachgeführten Datensatz fachlich überprüft haben, diesen aber nicht für die weitere Nutzung durch berechtigte Stellen genehmigen.",
                "COMMENT": "Bitte einen Kommentar eingeben."
            }
        }
    },
    "MESSAGEBOX": {
        "ERROR_REPORT": "Fehlerdatei",
        "CLOSE": "Schliessen"
    },
    "SUBSCRIPTION": {
        "TITLE": "Benachrichtigungen",
        "EVENTS": {
            "TITLE": "Benachrichtigung für Ereignisse konfigurieren"
        },
        "TOPICS": {
            "TITLE": "Benachrichtigung für Themen konfigurieren",
            "AVAILABLE": "Verfügbare Themen",
            "SELECTED": "Ausgewählte Themen"
        }
    },
    "BREADCRUMB": {
        "HOME": "Startseite",
        "APP": {
            "FTPSERVER": "FTP-Server",
            "FTPSERVER.EDIT": "FTP-Server-Verwaltung",
            "GEMEINDEN": "Gebiet",
            "GEMEINDEN.EDIT": "Gebietsverwaltung",
            "MAIN": "Pendenzenliste",
            "MODELS": "Modelle",
            "MODELS.EDIT": "Modellverwaltung",
            "ORGANISATIONS": "Organisationen",
            "ORGANISATIONS.EDIT": "Organisationsverwaltung",
            "PROFILE": "Profil",
            "PROFILEEVENTS": "Benachrichtigungen",
            "TOPICS": "Themen",
            "TOPICS.EDIT": "Themenverwaltung",
            "TRACKINGS": "Geodaten",
            "TRACKINGS.DATASETS": "Nachführungsverlauf",
            "TRACKINGS.DATASETS.EDIT": "Nachführungsschritt",
            "TRACKINGS.DATASETS.CHECKIN": "Check-in",
            "TRACKINGS.DISTRIBUTION": "Verteilungskonfiguration",
            "TRACKINGS.EDIT": "Geodatenverwaltung",
            "TRACKINGS.PROTOCOL": "Protokoll",
            "TRACKINGSDATASETS": "Daten Nachführungsverlauf",
            "TRACKINGSDISTRIBUTION": " Verteilungskonfiguration",
            "TRACKINGS.DISTRIBUTION.EDIT": "Verteilungskonfigurationsverwaltung",
            "USERS": "Benutzer",
            "USERS.EDIT": "Benutzerverwaltung"
        }
    },
    "SYSTEM": {
        "DEFAULT_SAVE_ERROR": "Fehler beim Speichern",
        "DEFAULT_SAVE_SUCCESS": "Erfolgreich gespeichert",
        "DEFAULT_DELETE_SUCCESS": "Erfolgreich gelöscht",
        "DELETE_CONFIRMATION": "Sind Sie sicher, dass Sie <strong>{{name}}</strong> löschen wollen? Das Element wird unwiderruflich gelöscht."
    },
    "KTAI": "Appenzell Innerrhoden",
    "KTAR": "Appenzell Ausserrhoden",
    "NOT_AUTHORIZED": "Dafür sind Sie nicht berechtigt",
    "GRID": {
        "REVERT_SETTINGS": "Standard Sortierung, Filter, Spaltenanordnung, -breite, etc. wiederherstellen"
    },
    "HANDBOOK": {
        "TITLE": "Handbuch",
        "BACK_TO_APP": "Zurück zur App"
    }
}
